import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CommonDataService } from './common-data/common-data.service';

@Pipe({
  name: 'translate',
  pure: false,
})
@Injectable({ providedIn: 'root' }) 
export class TranslatePipe implements PipeTransform {
  constructor(private commonData: CommonDataService) {}

  transform(key: any,module_name?: string): any {
    if(this.commonData.language_data){
// if(module_name){
//       if(this.commonData.language_data[module_name][key]){
//         return this.commonData.language_data[module_name][key];
//       }else{
//         return key;
//       }
//     }else{
      return this.commonData?.language_data[key?.trim()] || this.commonData?.english_value_obj[key?.trim()] || key;
    // }
    }else{
      return key;
    }
    
  }
}